import { createStores } from './store/utils';
import { CasinoGame, PaybackBooster, PaybackBoosterProgramGames } from '../services/casino/types';

export const paybackBooster = createStores({
    paybackBooster: undefined as PaybackBooster | undefined,
    games: [] as CasinoGame[],
    programGames: [] as PaybackBoosterProgramGames[],
    isExpired: false,
});
